import {
  type ControllerProps,
  useController,
  type Control,
  type FieldValues,
  type Path,
} from 'react-hook-form'

import {
  StyledErrorMessage,
  StyledInput,
  StyledInputWrapper,
} from './Form.Styled'

type InputFieldProps<T extends FieldValues> = {
  name: Path<T>
  control: Control<T>
  rules?: ControllerProps<T>['rules']
  type?: string
  label: string
}

export const InputField = <T extends FieldValues>({
  name,
  control,
  rules,
  type = 'text',
  label,
  ...rest
}: InputFieldProps<T>) => {
  const {
    field,
    fieldState: { error },
  } = useController<T>({ name, control, rules })

  return (
    <StyledInputWrapper>
      <label htmlFor={name}>{label}</label>
      <StyledInput {...field} type={type} {...rest} />
      {error && <StyledErrorMessage>{error.message}</StyledErrorMessage>}
    </StyledInputWrapper>
  )
}
